import { Button, Popover, Typography } from "@mui/material";
import { Calendar } from "react-date-range";
import { format } from "date-fns";
import { pickersMonthClasses } from "@mui/x-date-pickers";

const SingleDatePicker = ({ label, selectedDate, setSelectedDate, anchorEl, setAnchorEl }) => {
  const open = Boolean(anchorEl);
  const id = open ? `${label.toLowerCase().replace(" ", "-")}-picker` : undefined;
  const isLightTheme = process.env.REACT_APP_IS_LIGHT_THEME === "true";

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    handleClose();
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleClick}
        sx={{ textTransform: "none", fontSize: "14px", height: 40 , color:isLightTheme?"black":"white",borderColor: isLightTheme ? "black" : "white",}}
      >
        {selectedDate instanceof Date && !isNaN(selectedDate)
            ? format(selectedDate, "dd MMM yyyy")
            : "Select date"}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Calendar date={selectedDate} onChange={handleDateChange} />
      </Popover>
    </>
  );
};

export default SingleDatePicker;
